import React, { useState, useEffect, useRef } from "react";
import {
  Home,
  Ticket,
  ChevronLeft,
  FolderKanban,
  LogOut
} from "lucide-react";
import { NavLink , useNavigate} from "react-router-dom";
import VRSOrbitLogo from "../../../../../Assets/VRSorbit logo 1.png";
import VRSOrbitText from "../../../../../Assets/VRSorbit logo 2.png";
import NotificationAlert from "../../../../Alerts/NotificationAlert";
import ConfirmationAlert from "../../../../Alerts/ConfirmationAlert";
import Cookies from "js-cookie";
import { Logout } from "../../../../../Services/LoginService";

const AdminSidebar = () => {
   const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState(null);
  const panelRef = useRef(null);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [alert, setAlert] = useState(null);

  const menuItems = [
    {
      name: "Tickets",
      icon: Ticket,
      subItems: [
        { name: "All Tickets", path: "/All-Tickets" },
        { name: "New Tickets", path: "/New-Tickets" },
        { name: "Unassigned Tickets", path: "/Unassigned-Tickets" },
        { name: "Rejected Tickets", path: "/Rejected-Tickets" },
        { name: "Assigned Tickets", path: "/Assigned-Tickets" },
        { name: "In Progress Tickets", path: "/In-Progess-Tickets" },
        { name: "Ready for Review Tickets", path: "/Ready-For-Review-Tickets" },
         { name: "Assign To Reviewer Tickets", path: "/Assign-To-Reviewer-Tickets" },
        { name: "Review In Progress Tickets", path: "/Review-In-Progress-Tickets" },
        { name: "Reviewed Tickets", path: "/Reviewed-Tickets" },
        { name: "Hold Tickets", path: "/Hold-Tickets" },
        { name: "Closed Tickets", path: "/Closed-Tickets" },
        { name: "Reopen Tickets", path: "/Reopen-Tickets" }
      ],
    },
    {
      name: "Home",
      icon: Home,
      subItems: [
        { name: "Dashboard", path: "/Admin-Home" },
        { name: "Report", path: "/Admin-Report" },
        { name: "User History", path: "/User-History" },
      ],
    },
     {
      name: "Projects",
      icon: FolderKanban,
      subItems: [
        { name: "Projects", path: "/Admin-Project" },
        // { name: "Add-Developer", path: "/Admin-Project-Team" },
      ],
    },
    // { name: "Customers", icon: Users, path: "/customers" },
    // { name: "Channels", icon: MessageSquare, path: "/channels" },
    // { name: "Macros", icon: Layers, path: "/macros" },
    // { name: "Settings", icon: Settings, path: "/settings" },
  ];

  // Close side panel when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setActiveMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMenuClick = (name, hasSubmenu) => {
    if (!hasSubmenu) return setActiveMenu(null);
    setActiveMenu((prev) => (prev === name ? null : name));
  };

   const handleLogoutClick = () => {
      setShowLogoutConfirm(true);
    };
  
    const confirmLogout = async () => {
      try {
        const res = await Logout();
  
        setAlert({
          type: "success",
          message: res.data?.message || "Logged out successfully!",
        });
  
        Cookies.remove("Orbit_Token");
  
        setTimeout(() => {
          window.location.href = "/";
        }, 4000);
      } catch (err) {
         if (err.response?.status === 400) {
      navigate("/bad-request", {
        state: {
          error: err.response?.data?.message || "Bad request (400)",
        },
      });
      return;
    }
        setAlert({
          type: "error",
          message:
            err.response?.data?.message || "Logout failed. Please try again.",
        });
      }
      setShowLogoutConfirm(false);
    };

  return (
    <div className="flex h-screen">
      {/* Main Sidebar */}
      <div className="w-20 bg-white shadow-md flex flex-col items-center py-4 border-r">
        <img src={VRSOrbitLogo} alt="Logo" className="h-10 mb-6" />
        <nav className="flex-1 flex flex-col items-center space-y-2">
          {menuItems.map(({ name, icon: Icon, subItems }) => (
            <button
              key={name}
              onClick={() => handleMenuClick(name, !!subItems)}
              className={`flex flex-col items-center justify-center w-14 h-14 rounded-lg hover:bg-blue-50 transition ${
                activeMenu === name
                  ? "bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white"
                  : "text-gray-700"
              }`}
            >
              <Icon size={22} />
              <span className="text-[10px] mt-1">{name}</span>
            </button>
          ))}
        </nav>

        <div className="mt-auto pb-2">
          <button
            onClick={handleLogoutClick}
            className={`flex flex-col items-center justify-center w-14 h-14 rounded-lg text-gray-700 hover:bg-blue-50 hover:text-[#0061A4] transition group`}
          >
            <LogOut
              size={22}
              className="group-hover:text-[#0061A4] transition duration-200"
            />
            <span className="text-[10px] mt-1 group-hover:text-[#0061A4]">
              Logout
            </span>
          </button>
        </div>
      </div>

      {/* Floating Side Panel */}
      {activeMenu && (
        <div
          ref={panelRef}
          className="w-48 bg-white border-r shadow-md p-4 animate-slide-in"
        >
          <img
            src={VRSOrbitText}
            alt="Logo"
            className="w-[150px] h-5 mt-4 mb-6"
          />
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-medium text-gray-700">{activeMenu}</h3>
            <ChevronLeft
              size={18}
              onClick={() => setActiveMenu(null)}
              className="cursor-pointer text-gray-500 hover:text-gray-700"
            />
          </div>

          {/* Submenu Items */}
          {menuItems
            .find((item) => item.name === activeMenu)
            ?.subItems?.map((sub) => (
              <NavLink
                key={sub.name}
                to={sub.path}
                className={({ isActive }) =>
                  `block px-3 py-2 rounded-md text-sm mb-1 transition-all duration-200 hover:bg-gradient-to-r from-[#0061A4] to-[#00ACED] 
                 hover:text-white ${
                   isActive ? "text-gray-600 font-medium" : "text-gray-600"
                 }`
                }
              >
                {sub.name}
              </NavLink>
            ))}
        </div>
      )}

       <ConfirmationAlert
        show={showLogoutConfirm}
        title="Logout Confirmation"
        message="Are you sure you want to logout?"
        onConfirm={confirmLogout}
        onCancel={() => setShowLogoutConfirm(false)}
      />

      <NotificationAlert
        show={alert !== null}
        type={alert?.type}
        message={alert?.message}
        duration={4000}
        onClose={() => setAlert(null)}
      />
    </div>
  );
};

export default AdminSidebar;
